<!--XXXXX-->
<template>
  <div class="main-container">
    <!-- <div class="physique">
            <div class="physique-img">
                <left style="color:#ffffff;"></left>
            </div>
        </div> -->
    <div @click="$router.go(-1)" style="background: #fff; padding: 16px 10px 10px">
      <van-icon name="arrow-left" size="22" />
      <span style="margin-left: 35%; font-weight: 600; font-size: 18px">饮食记录</span>
    </div>
    <div class="all-date-box">
      <!--日期选择-->
      <div class="date-choose-box flex ac jb" @click="dateShow = !dateShow">
        <div class="date-word">
          <span v-if="chooseYear">{{ chooseYear }}年</span>
          <span v-if="chooseMonth">{{ chooseMonth }}月</span>
          <span v-if="chooseDay">{{ chooseDay }}日</span>
        </div>
        <div>
          <van-icon name="arrow-down" size="16" color="#000000" />
        </div>
      </div>

      <!--日历展开-->
      <div class="opened-box" v-show="dateShow">
        <div class="flex ac pd20">
          <div class="choose-box flex ac jc mr15" @click="showYear = true">
            <p class="mr10">{{ chooseYear }}年</p>
            <van-icon name="arrow-down" size="16" color="#000000" />
          </div>
          <div class="choose-box flex ac jc" @click="showMonth = true">
            <p class="mr10">{{ chooseMonth }}月</p>
            <van-icon name="arrow-down" size="16" color="#000000" />
          </div>
        </div>
        <van-calendar
          title="日历"
          :poppable="false"
          :show-confirm="false"
          :formatter="formatter"
          :show-subtitle="false"
          :min-date="minDate"
          :maxDate="new Date()"
          @confirm="handleDate"
          :style="{ height: '500px', borderRadius: '8px' }"
        />
      </div>
    </div>
    <div class="total-box mb15 pb15" :class="JSON.stringify(totalList) == '{}' || !totalList ? 'pt15' : ''">
      <Echart v-if="JSON.stringify(totalList) != '{}' && totalList" :options="option" id="huanChart" height="200px" width="100%"></Echart>
      <div class="total-nl flex ac jb">
        <div>总能量</div>
        <div>{{ totalList && totalList.total_eng_kcal ? totalList.total_eng_kcal : 0 }}千卡</div>
      </div>
      <div class="H_title flex ac jb">
        <p>营养素</p>
        <p>摄入量</p>
        <p>热量比</p>
      </div>
      <div class="info-box" v-if="JSON.stringify(totalList) != '{}' && totalList">
        <div class="flex ac jb">
          <p>碳水化合物</p>
          <p>{{ totalList.total_tanshui.toFixed(2) }}g</p>
          <p>{{ totalList.per_tanshui.toFixed(2) }}%</p>
        </div>
        <div class="flex ac jb">
          <p>蛋白质</p>
          <p>{{ totalList.total_danbaizhi.toFixed(2) }}g</p>
          <p>{{ totalList.per_danbaizhi.toFixed(2) }}%</p>
        </div>
        <div class="flex ac jb">
          <p>脂肪</p>
          <p>{{ totalList.total_zhifang.toFixed(2) }}g</p>
          <p>{{ totalList.per_zhifang.toFixed(2) }}%</p>
        </div>
        <div class="flex ac jb">
          <p>膳食纤维</p>
          <p>{{ totalList.total_shanshi.toFixed(2) }}g</p>
          <p>{{ totalList.per_shanshi.toFixed(2) }}%</p>
        </div>
      </div>
      <div v-else class="tc" style="color: #b3b3b3">暂未录入</div>
    </div>
    <!--早餐-->
    <div class="meal-box mb15">
      <div class="flex ac jb">
        <div>
          <span class="mr05">早餐</span>
          <span style="color: #c7c7c7" v-if="zaoList && zaoList.total_calorie">摄入{{ zaoList.total_calorie.toFixed(2) }}千卡</span>
        </div>
        <div class="right-zhan flex ac">
          <p class="pp1">当日热量比</p>
          <p class="pp2" v-if="each_meal.zao">{{ each_meal.zao.toFixed(2) }}%</p>
          <p v-else class="pp2">0%</p>
        </div>
      </div>
      <div class="H_title flex ac jb">
        <p>营养素</p>
        <p>摄入量</p>
        <p>热量比</p>
      </div>

      <div class="info-box" v-if="JSON.stringify(zaoList) != '{}'">
        <div class="flex ac jb">
          <p>碳水化合物</p>
          <p>{{ zaoList.total_tanshui.toFixed(2) }}g</p>
          <p>{{ zaoList.per_tanshui.toFixed(2) }}%</p>
        </div>
        <div class="flex ac jb">
          <p>蛋白质</p>
          <p>{{ zaoList.total_danbaizhi.toFixed(2) }}g</p>
          <p>{{ zaoList.per_danbaizhi.toFixed(2) }}%</p>
        </div>
        <div class="flex ac jb">
          <p>脂肪</p>
          <p>{{ zaoList.total_zhifang.toFixed(2) }}g</p>
          <p>{{ zaoList.per_zhifang.toFixed(2) }}%</p>
        </div>
        <div class="flex ac jb">
          <p>膳食纤维</p>
          <p>{{ zaoList.total_shanshi.toFixed(2) }}g</p>
          <p>{{ zaoList.per_shanshi.toFixed(2) }}%</p>
        </div>
      </div>
      <div v-else class="tc" style="color: #b3b3b3">暂未录入</div>

      <div class="btn-box" @click="goEdit(1)">录入/修改</div>
    </div>

    <!--早加餐-->
    <div class="meal-box mb15">
      <div class="flex ac jb">
        <div>
          <span class="mr05">早加餐</span>
          <span style="color: #c7c7c7" v-if="zaoJiaList.total_calorie">摄入{{ zaoJiaList.total_calorie.toFixed(2) }}千卡</span>
        </div>
        <div class="right-zhan flex ac">
          <p class="pp1">当日热量比</p>
          <p class="pp2" v-if="each_meal.zao_jia">{{ each_meal.zao_jia.toFixed(2) }}%</p>
          <p v-else class="pp2">0%</p>
        </div>
      </div>
      <div class="H_title flex ac jb">
        <p>营养素</p>
        <p>摄入量</p>
        <p>热量比</p>
      </div>

      <div class="info-box" v-if="JSON.stringify(zaoJiaList) != '{}'">
        <div class="flex ac jb">
          <p>碳水化合物</p>
          <p>{{ zaoJiaList.total_tanshui.toFixed(2) }}g</p>
          <p>{{ zaoJiaList.per_tanshui.toFixed(2) }}%</p>
        </div>
        <div class="flex ac jb">
          <p>蛋白质</p>
          <p>{{ zaoJiaList.total_danbaizhi.toFixed(2) }}g</p>
          <p>{{ zaoJiaList.per_danbaizhi.toFixed(2) }}%</p>
        </div>
        <div class="flex ac jb">
          <p>脂肪</p>
          <p>{{ zaoJiaList.total_zhifang.toFixed(2) }}g</p>
          <p>{{ zaoJiaList.per_zhifang.toFixed(2) }}%</p>
        </div>
        <div class="flex ac jb">
          <p>膳食纤维</p>
          <p>{{ zaoJiaList.total_shanshi.toFixed(2) }}g</p>
          <p>{{ zaoJiaList.per_shanshi.toFixed(2) }}%</p>
        </div>
      </div>
      <div v-else class="tc" style="color: #b3b3b3">暂未录入</div>

      <div class="btn-box" @click="goEdit(2)">录入/修改</div>
    </div>

    <!--午餐-->
    <div class="meal-box mb15">
      <div class="flex ac jb">
        <div>
          <span class="mr05">午餐</span>
          <span style="color: #c7c7c7" v-if="zhongList.total_calorie">摄入{{ zhongList.total_calorie.toFixed(2) }}千卡</span>
        </div>
        <div class="right-zhan flex ac">
          <p class="pp1">当日热量比</p>
          <p class="pp2" v-if="each_meal.zhong">{{ each_meal.zhong.toFixed(2) }}%</p>
          <p v-else class="pp2">0%</p>
        </div>
      </div>
      <div class="H_title flex ac jb">
        <p>营养素</p>
        <p>摄入量</p>
        <p>热量比</p>
      </div>

      <div class="info-box" v-if="JSON.stringify(zhongList) != '{}'">
        <div class="flex ac jb">
          <p>碳水化合物</p>
          <p>{{ zhongList.total_tanshui.toFixed(2) }}g</p>
          <p>{{ zhongList.per_tanshui.toFixed(2) }}%</p>
        </div>
        <div class="flex ac jb">
          <p>蛋白质</p>
          <p>{{ zhongList.total_danbaizhi.toFixed(2) }}g</p>
          <p>{{ zhongList.per_danbaizhi.toFixed(2) }}%</p>
        </div>
        <div class="flex ac jb">
          <p>脂肪</p>
          <p>{{ zhongList.total_zhifang.toFixed(2) }}g</p>
          <p>{{ zhongList.per_zhifang.toFixed(2) }}%</p>
        </div>
        <div class="flex ac jb">
          <p>膳食纤维</p>
          <p>{{ zhongList.total_shanshi.toFixed(2) }}g</p>
          <p>{{ zhongList.per_shanshi.toFixed(2) }}%</p>
        </div>
      </div>
      <div v-else class="tc" style="color: #b3b3b3">暂未录入</div>

      <div class="btn-box" @click="goEdit(3)">录入/修改</div>
    </div>

    <!--午加餐-->
    <div class="meal-box mb15">
      <div class="flex ac jb">
        <div>
          <span class="mr05">午加餐</span>
          <span style="color: #c7c7c7" v-if="zhongJiaList.total_calorie">摄入{{ zhongJiaList.total_calorie.toFixed(2) }}千卡</span>
        </div>
        <div class="right-zhan flex ac">
          <p class="pp1">当日热量比</p>
          <p class="pp2" v-if="each_meal.zhong_jia">{{ each_meal.zhong_jia.toFixed(2) }}%</p>
          <p v-else class="pp2">0%</p>
        </div>
      </div>
      <div class="H_title flex ac jb">
        <p>营养素</p>
        <p>摄入量</p>
        <p>热量比</p>
      </div>

      <div class="info-box" v-if="JSON.stringify(zhongJiaList) != '{}'">
        <div class="flex ac jb">
          <p>碳水化合物</p>
          <p>{{ zhongJiaList.total_tanshui.toFixed(2) }}g</p>
          <p>{{ zhongJiaList.per_tanshui.toFixed(2) }}%</p>
        </div>
        <div class="flex ac jb">
          <p>蛋白质</p>
          <p>{{ zhongJiaList.total_danbaizhi.toFixed(2) }}g</p>
          <p>{{ zhongJiaList.per_danbaizhi.toFixed(2) }}%</p>
        </div>
        <div class="flex ac jb">
          <p>脂肪</p>
          <p>{{ zhongJiaList.total_zhifang.toFixed(2) }}g</p>
          <p>{{ zhongJiaList.per_zhifang.toFixed(2) }}%</p>
        </div>
        <div class="flex ac jb">
          <p>膳食纤维</p>
          <p>{{ zhongJiaList.total_shanshi.toFixed(2) }}g</p>
          <p>{{ zhongJiaList.per_shanshi.toFixed(2) }}%</p>
        </div>
      </div>
      <div v-else class="tc" style="color: #b3b3b3">暂未录入</div>

      <div class="btn-box" @click="goEdit(4)">录入/修改</div>
    </div>

    <!--晚餐-->
    <div class="meal-box mb15">
      <div class="flex ac jb">
        <div>
          <span class="mr05">晚餐</span>
          <span style="color: #c7c7c7" v-if="wanList.total_calorie">摄入{{ wanList.total_calorie.toFixed(2) }}千卡</span>
        </div>
        <div class="right-zhan flex ac">
          <p class="pp1">当日热量比</p>
          <p class="pp2" v-if="each_meal.wan">{{ each_meal.wan.toFixed(2) }}%</p>
          <p v-else class="pp2">0%</p>
        </div>
      </div>
      <div class="H_title flex ac jb">
        <p>营养素</p>
        <p>摄入量</p>
        <p>热量比</p>
      </div>

      <div class="info-box" v-if="JSON.stringify(wanList) != '{}'">
        <div class="flex ac jb">
          <p>碳水化合物</p>
          <p>{{ wanList.total_tanshui.toFixed(2) }}g</p>
          <p>{{ wanList.per_tanshui.toFixed(2) }}%</p>
        </div>
        <div class="flex ac jb">
          <p>蛋白质</p>
          <p>{{ wanList.total_danbaizhi.toFixed(2) }}g</p>
          <p>{{ wanList.per_danbaizhi.toFixed(2) }}%</p>
        </div>
        <div class="flex ac jb">
          <p>脂肪</p>
          <p>{{ wanList.total_zhifang.toFixed(2) }}g</p>
          <p>{{ wanList.per_zhifang.toFixed(2) }}%</p>
        </div>
        <div class="flex ac jb">
          <p>膳食纤维</p>
          <p>{{ wanList.total_shanshi.toFixed(2) }}g</p>
          <p>{{ wanList.per_shanshi.toFixed(2) }}%</p>
        </div>
      </div>
      <div v-else class="tc" style="color: #b3b3b3">暂未录入</div>

      <div class="btn-box" @click="goEdit(5)">录入/修改</div>
    </div>
    <!--晚加餐-->
    <div class="meal-box mb15">
      <div class="flex ac jb">
        <div>
          <span class="mr05">晚加餐</span>
          <span style="color: #c7c7c7" v-if="wanJiaList.total_calorie">摄入{{ wanJiaList.total_calorie.toFixed(2) }}千卡</span>
        </div>
        <div class="right-zhan flex ac">
          <p class="pp1">当日热量比</p>
          <p class="pp2" v-if="each_meal.wan_jia">{{ each_meal.wan_jia.toFixed(2) }}%</p>
          <p v-else class="pp2">0%</p>
        </div>
      </div>
      <div class="H_title flex ac jb">
        <p>营养素</p>
        <p>摄入量</p>
        <p>热量比</p>
      </div>

      <div class="info-box" v-if="JSON.stringify(wanJiaList) != '{}'">
        <div class="flex ac jb">
          <p>碳水化合物</p>
          <p>{{ wanJiaList.total_tanshui.toFixed(2) }}g</p>
          <p>{{ wanJiaList.per_tanshui.toFixed(2) }}%</p>
        </div>
        <div class="flex ac jb">
          <p>蛋白质</p>
          <p>{{ wanJiaList.total_danbaizhi.toFixed(2) }}g</p>
          <p>{{ wanJiaList.per_danbaizhi.toFixed(2) }}%</p>
        </div>
        <div class="flex ac jb">
          <p>脂肪</p>
          <p>{{ wanJiaList.total_zhifang.toFixed(2) }}g</p>
          <p>{{ wanJiaList.per_zhifang.toFixed(2) }}%</p>
        </div>
        <div class="flex ac jb">
          <p>膳食纤维</p>
          <p>{{ wanJiaList.total_shanshi.toFixed(2) }}g</p>
          <p>{{ wanJiaList.per_shanshi.toFixed(2) }}%</p>
        </div>
      </div>
      <div v-else class="tc" style="color: #b3b3b3">暂未录入</div>

      <div class="btn-box" @click="goEdit(6)">录入/修改</div>
    </div>

    <van-popup v-model="showYear" round position="bottom">
      <van-picker title="年份选择" show-toolbar :columns="yearList" @cancel="showYear = false" @confirm="handleYear" />
    </van-popup>

    <van-popup v-model="showMonth" round position="bottom">
      <van-picker title="月份选择" show-toolbar :columns="monthList" @cancel="showMonth = false" @confirm="handleMonth" />
    </van-popup>
  </div>
</template>
<script>
import { dietList, recordDetails } from "../service/api";
import Echart from "@/common/echart";
import Vue from "vue";
import { Calendar, Picker, Popup } from "vant";
// import left from '../components/arrow-left'

Vue.use(Calendar);
Vue.use(Picker);
Vue.use(Popup);
export default {
  name: "youTest",
  components: {
    Echart,
    // left
  },
  data() {
    return {
      option: {
        tooltip: {
          trigger: "item",
          formatter: function (params) {
            //标签内容
            return params.name + "占比" + params.value + "%";
          },
        },
        legend: {
          data: ["碳水化合物", "蛋白质", "脂肪", "膳食纤维"],
          textStyle: {
            fontSize: 12, //字体大小
            color: "#000000", //字体颜色
          },
          orient: "vertical",
          x: "left",
          left: "70%",
          top: "25%",
          selectedMode: false,

          // // top: '15%',
          // // right: '25%',
          // x: 'left',
        },

        series: [
          {
            name: "",
            type: "pie",
            radius: ["40%", "70%"],
            label: {
              show: false,
              position: "center",
            },

            emphasis: {
              label: {
                show: true,
                fontSize: 12,
                fontWeight: "bold",
              },
            },
            labelLine: {
              show: false,
            },
            center: ["35%", "55%"],
            data: [
              { value: 0, name: "碳水化合物" },
              { value: 0, name: "蛋白质" },
              { value: 0, name: "脂肪" },
              { value: 0, name: "膳食纤维" },
            ],
          },
        ],
      },
      dateShow: false,
      // 后端返会的数据
      dietList: [],
      chooseYear: "",
      chooseMonth: "",
      chooseDay: "",
      showYear: false,
      showMonth: false,
      yearList: [],
      monthList: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
      minDate: new Date(),
      maxDate: new Date(),
      //记录这个月那几天是需要补填的数组
      fillList: [],
      zaoList: {},
      zaoJiaList: {},
      zhongList: {},
      zhongJiaList: {},
      wanList: {},
      wanJiaList: {},
      totalList: {},
      each_meal: {},
    };
  },
  created() {
    this.initData();
  },
  methods: {
    formatter(day) {
      const date = day.date.getDate();
      if (this.fillList.indexOf(date) > -1) {
        day.topInfo = "补填";
      }
      return day;
    },
    // 初始化时间
    initData() {
      let date = new Date();

      if (this.$route.query.date) {
        this.chooseYear = this.$route.query.date.split("-")[0];
        this.chooseMonth = this.$route.query.date.split("-")[1];
        this.chooseDay = this.$route.query.date.split("-")[2];
      } else {
        this.chooseYear = date.getFullYear();
        this.chooseMonth = date.getMonth() + 1;
        this.chooseDay = date.getDate();
      }

      for (let i = parseInt(this.chooseYear); i >= 2000; i--) {
        this.yearList.push(i);
      }
      dietList({ year: this.chooseYear, months: this.chooseMonth }).then((res) => {
        if (res.data.list) {
          let length = res.data.list.length;
          this.minDate = new Date(res.data.list[0].date.split("-")[0], parseInt(res.data.list[0].date.split("-")[1]) - 1, 1);
          this.maxDate = new Date(
            res.data.list[length - 1].date.split("-")[0],
            parseInt(res.data.list[length - 1].date.split("-")[1]) - 1,
            res.data.list[length - 1].date.split("-")[2]
          );
          this.dietList = res.data.list;
          this.dietList.forEach((item, index) => {
            if (item.is_write == 0 && parseInt(item.date.split("-")[2]) < this.chooseDay) {
              this.fillList.push(parseInt(item.date.split("-")[2]));
            }
          });
        }
      });
      this.getList(this.chooseYear + "-" + this.chooseMonth + "-" + this.chooseDay);
    },

    // 获取日期下的数据
    getList(date) {
      recordDetails({ date: date }).then((res) => {
        this.zaoList = res.data.list.zao;
        this.zaoJiaList = res.data.list.zao_jia;
        this.zhongList = res.data.list.zhong;
        this.zhongJiaList = res.data.list.zhong_jia;
        this.wanList = res.data.list.wan;
        this.wanJiaList = res.data.list.wan_jia;
        this.totalList = res.data.total;
        this.each_meal = res.data.each_meal;
        if (res.data.total) {
          this.option.series[0].data[0].value = res.data.total.per_tanshui.toFixed(2);
          this.option.series[0].data[1].value = res.data.total.per_danbaizhi.toFixed(2);
          this.option.series[0].data[2].value = res.data.total.per_zhifang.toFixed(2);
          this.option.series[0].data[3].value = res.data.total.per_shanshi.toFixed(2);
        }
      });
    },
    // 格式化时间
    // formatDate(date) {
    //     return `${this.chooseYear}-${date.getMonth() + 1}-${date.getDate()}`;
    // },
    // 选择具体时间
    handleDate(date) {
      this.dateShow = false;
      this.chooseMonth = date.getMonth() + 1;
      this.chooseDay = date.getDate();
      // this.formatDate(date)
      this.getList(this.chooseYear + "-" + this.chooseMonth + "-" + this.chooseDay);
    },
    handleYear(val) {
      this.chooseYear = val;
      this.chooseMonth = "";
      this.chooseDay = "";
      this.getDate(val, this.chooseMonth);
      this.showYear = false;
    },
    handleMonth(val) {
      this.chooseMonth = val;
      this.chooseDay = "";
      this.getDate(this.chooseYear, val);
      this.showMonth = false;
    },
    // 根据年月来查询日历数据
    getDate(val1, val2) {
      let date = new Date();
      // this.chooseYear = date.getFullYear()
      // this.chooseMonth = date.getMonth() + 1
      // this.chooseDay = date.getDate()
      dietList({ year: val1, months: val2 }).then((res) => {
        if (res.data.list) {
          let length = res.data.list.length;
          this.minDate = new Date(res.data.list[0].date.split("-")[0], parseInt(res.data.list[0].date.split("-")[1]) - 1, 1);
          this.maxDate = new Date(
            res.data.list[length - 1].date.split("-")[0],
            parseInt(res.data.list[length - 1].date.split("-")[1]) - 1,
            res.data.list[length - 1].date.split("-")[2]
          );
          this.dietList = res.data.list;
          this.fillList = [];

          // 当年当月
          if (val1 == date.getFullYear() && val2 == date.getMonth() + 1) {
            this.chooseDay = date.getDate();
            this.dietList.forEach((item, index) => {
              if (item.is_write == 0 && parseInt(item.date.split("-")[2]) < this.chooseDay) {
                this.fillList.push(parseInt(item.date.split("-")[2]));
              }
            });
            this.getList(this.chooseYear + "-" + this.chooseMonth + "-" + this.chooseDay);
          }
          // 当年前月
          else if (val1 == date.getFullYear() && val2 < parseInt(date.getMonth() + 1)) {
            this.dietList.forEach((item, index) => {
              if (item.is_write == 0) {
                this.fillList.push(parseInt(item.date.split("-")[2]));
              }
            });
          }
          // 当年后月
          // 前年
          else if (val1 < date.getFullYear()) {
            this.dietList.forEach((item, index) => {
              if (item.is_write == 0) {
                this.fillList.push(parseInt(item.date.split("-")[2]));
              }
            });
          }
          console.log("this.fillList", this.fillList);
          // this.dietList.forEach((item, index) => {
          //   if (item.is_write == 0) {
          //     this.fillList.push(parseInt(item.date.split('-')[2]))
          //   }
          // })
        }
      });
    },
    goEdit(id) {
      if (this.chooseMonth && this.chooseDay) {
        this.$router.replace({
          path: "/physique/foodsListChose",
          query: {
            date: this.chooseYear + "-" + this.chooseMonth + "-" + this.chooseDay,
            id: id,
            type: 2,
          },
          // this.$router.push({path:'/physique/edit',query:{'id':id,'type':2,'date':this.$route.query.date}})
        });
      } else {
        this.$toast("请选择具体时间");
      }
    },
  },
  /**加载完组件时执行(加载完成之后执行)*/
  mounted() {},
};
</script>

<style lang="scss" scoped>
.main-container {
  background: #f0f2f9;
  min-height: 100vh;
  //   padding-top: 20px;
  .physique {
    width: 375px;
    height: 156px;
    background: url("../assets/imgs/饮食-pic@2x.png");
    background-size: 100% auto;

    .physique-img {
      padding-top: 25px;
      margin-left: 16px;
    }
  }

  .all-date-box {
    background: #ffffff;
    position: relative;
    margin-bottom: 16px;
    margin-top: 20px;

    .date-choose-box {
      box-sizing: border-box;
      padding: 10px 16px;
      width: 343px;
      margin: 0 auto;
      height: 43px;
      background: #ffffff;
      border-radius: 8px;

      .date-word {
        font-size: 16px;
        font-weight: 400;
        color: #000000;
      }
    }

    .opened-box {
      position: absolute;
      width: 375px;
      min-height: 343px;
      background: #ffffff;
      top: 53px;
      left: 0px;
      z-index: 99;
      border-radius: 8px;

      .choose-box {
        width: 97px;
        height: 32px;
        line-height: 32px;
        border-radius: 16px;
        border: 1px solid #c5c5c5;
      }
    }
  }

  .total-box {
    background: #ffffff;
    border-radius: 8px;
  }

  .meal-box {
    padding: 16px;
    background: #ffffff;
    border-radius: 8px;

    .right-zhan {
      margin: 0;

      p {
        text-align: center;
        margin: 0;
        font-size: 14px;
        font-weight: 400;
        line-height: 16px;
      }

      .pp1 {
        box-sizing: border-box;
        width: 87px;
        height: 27px;
        line-height: 27px;
        color: #3662ec;
        border-bottom-left-radius: 16px;
        border-top-left-radius: 16px;
        border: 1px solid #3662ec;
      }

      .pp2 {
        font-size: 10px;
        width: 48px;
        height: 27px;
        line-height: 27px;
        color: #ffffff;
        background: #3662ec;
        border-bottom-right-radius: 16px;
        border-top-right-radius: 16px;
      }
    }
  }

  .total-nl {
    width: 312px;
    margin: 6px auto 6px;
  }

  .H_title {
    width: 312px;
    margin: 17px auto 6px;
    height: 32px;
    background: #f0f2f9;
    border-radius: 16px;
    line-height: 32px;

    p {
      width: 104px;
      text-align: center;
      font-size: 14px;
      font-weight: 500;
      color: #888888;
    }
  }

  .info-box {
    width: 312px;
    margin: 0 auto;

    p {
      margin: 5px 0;
      width: 104px;
      text-align: center;
      font-size: 14px;
      font-weight: 500;
      color: #222222;
    }
  }

  .btn-box {
    width: 311px;
    height: 44px;
    margin: 15px auto;
    background: #224a91;
    border-radius: 4px;
    line-height: 44px;
    text-align: center;
    color: #ffffff;
  }
}
</style>
<style>
.main-container .van-calendar__top-info {
  color: red !important;
}

.main-container .van-calendar__selected-day .van-calendar__top-info {
  color: #eeeeee !important;
}
</style>
